// getGameData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

const defaultSelectPath = [];
const defaultDataKey = '';

/**
 * Select game data by select path
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} selectPath - select path.
 * @param {string} dataKey - data key.
 * @return {any} The selected game data.
 */
const getGameData = createCachedSelector(
  (state, selectPath = defaultSelectPath) =>
    state.getIn(['games', ...selectPath]),
  (state, selectPath, dataKey) => dataKey,
  (game, dataKey = defaultDataKey) => {
    let result = game;
    if (dataKey) {
      result = game?.get(dataKey);
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)(
  (state, selectPath = defaultSelectPath, dataKey = defaultDataKey) =>
    `${selectPath.join(':')}:${dataKey}`
);

export default getGameData;
